import { render } from "./TaskUpdate.vue?vue&type=template&id=790a055c&scoped=true"
import script from "./TaskUpdate.vue?vue&type=script&lang=js"
export * from "./TaskUpdate.vue?vue&type=script&lang=js"

import "./TaskUpdate.vue?vue&type=style&index=0&id=790a055c&scoped=true&lang=css"
import "./TaskUpdate.vue?vue&type=style&index=1&id=790a055c&scoped=true&lang=css"
import "./TaskUpdate.vue?vue&type=style&index=2&id=790a055c&scoped=true&lang=css"
import "./TaskUpdate.vue?vue&type=style&index=3&id=790a055c&scoped=true&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-790a055c"]])

export default __exports__